import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=53fc654e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=53fc654e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../CrossD.Portal.Vue/ClientApp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports